export class ActionPlan {
    constructor(id, creationDate, user, coach, actionPlanItems) {
        this.id = id;
        this.creationDate = creationDate;
        this.user = user;
        this.coach = coach;
        this.actionPlanItems = actionPlanItems;
    }
}
